import { ThemeProvider } from '@mui/styles';
import React, { Component } from 'react';
import theme from '../styles/theme';

const Logo = '/assets/images/logo-pernik-hsi.png'

const SvgCircle = (props) => {
	const { className, done, max, radius, stroke, strokeWidth } = props
	const size = (radius + strokeWidth) * 2
	const length = Math.ceil(2 * radius * Math.PI)
	const remainingLength = length - (Math.ceil(2 * radius * Math.PI) * (done / max))
	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox={`0 0 ${size} ${size}`}
			xmlns="http://www.w3.org/2000/svg"
		>
			<g>
				<circle
					className="circle"
					r={radius}
					cx={radius + strokeWidth}
					cy={radius + strokeWidth}
					stroke={stroke}
					strokeDasharray={length}
					strokeDashoffset={remainingLength}
					strokeLinecap="round"
					strokeWidth={strokeWidth}
					fill="none"
				/>
				<circle
					className="circle--bg"
					r={radius}
					cx={radius + strokeWidth}
					cy={radius + strokeWidth}
					stroke="rgba(0, 0, 0, .1)"
					strokeLinecap="round"
					strokeWidth={strokeWidth}
					fill="none"
				/>
			</g>
		</svg>
	)
}

SvgCircle.defaultProps = {
	done: 0,
	max: 24,
	radius: 35,
	stroke: '#00BFE6',
	strokeWidth: 8,
}

class ComingSoon extends Component {

	constructor(props) {
		super(props);

		this.state = {
			date: '2020-06-31 12:00:00',
			days: 0,
			hours: 0,
			min: 0,
			sec: 0,
		}
	}

	componentDidMount() {
		// update every second
		this.interval = setInterval(() => {
			const date = this.calculateCountdown(this.state.date);
			date ? this.setState(date) : this.stop();
		}, 1000);
	}

	componentWillUnmount() {
		this.stop();
	}

	calculateCountdown(endDate) {
		let diff = (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000;

		// clear countdown when date is reached
		if (diff <= 0) return false;

		const timeLeft = {
			years: 0,
			days: 0,
			hours: 0,
			min: 0,
			sec: 0,
			millisec: 0,
		};

		// calculate time difference between now and expected date
		if (diff >= (365.25 * 86400)) { // 365.25 * 24 * 60 * 60
			timeLeft.years = Math.floor(diff / (365.25 * 86400));
			diff -= timeLeft.years * 365.25 * 86400;
		}
		if (diff >= 86400) { // 24 * 60 * 60
			timeLeft.days = Math.floor(diff / 86400);
			diff -= timeLeft.days * 86400;
		}
		if (diff >= 3600) { // 60 * 60
			timeLeft.hours = Math.floor(diff / 3600);
			diff -= timeLeft.hours * 3600;
		}
		if (diff >= 60) {
			timeLeft.min = Math.floor(diff / 60);
			diff -= timeLeft.min * 60;
		}
		timeLeft.sec = diff;

		return timeLeft;
	}

	stop() {
		clearInterval(this.interval);
	}

	addLeadingZeros(value) {
		value = String(value);
		while (value.length < 2) {
			value = '0' + value;
		}
		return value;
	}

	render() {
		return (
			<ThemeProvider theme={theme}>
				<div className="header">
					<a target="_blank" rel="noopener noreferrer" href="./about.html" className="center" style={{ padding: 10, textAlign: "center" }}>
						<img alt="icon" src={Logo} style={{ height: 45 }} />
					</a>
				</div>
				<div className="wrapper-white">
					<div className="countdown">
						<div className="clock__display">
							<SvgCircle max={60} done={this.state.days} />
							<div className="clock__text clock__text--days">
								<span className="clock__amount">{this.addLeadingZeros(this.state.days)}</span>
								<span className="clock__unit">Hari</span>
							</div>
						</div>

						<div className="clock__display">
							<SvgCircle max={60} done={this.state.hours} />
							<div className="clock__text clock__text--hours">
								<span className="clock__amount">{this.addLeadingZeros(this.state.hours)}</span>
								<span className="clock__unit">Jam</span>
							</div>
						</div>

						<div className="clock__display">
							<SvgCircle max={60} done={this.state.min} />
							<div className="clock__text clock__text--min">
								<span className="clock__amount">{this.addLeadingZeros(this.state.min)}</span>
								<span className="clock__unit">Menit</span>
							</div>
						</div>

						<div className="clock__display">
							<SvgCircle max={60} done={this.state.sec} />
							<div className="clock__text clock__text--sec">
								<span className="clock__amount">{this.addLeadingZeros(this.state.sec)}</span>
								<span className="clock__unit">Detik</span>
							</div>
						</div>
					</div>

					<h3>Something awesome is coming soon</h3>
					<h4>We are building something very cool. Stay tuned and be patient. Your patience will be well paid.</h4>
				</div>
			</ThemeProvider>
		);
	}
}

export default ComingSoon
